import React from "react";
import {
	Box,
	Typography,
	Radio,
	RadioGroup,
	FormControl,
	FormControlLabel,
	TextField,
} from "@mui/material";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";
import { ESRFieldProps } from "../../types/data";
import { useRemoteField } from "../../hooks/useRemoteField";

// Sent to agency, awaiting response
export const ESRSentResponseField = (props: ESRFieldProps) => {
	const { question_id, locked } = props;
	const { esrId = "" } = useParams();

	const [value, setValue] = useRemoteField(question_id);

	// Main question has several sub-questions
	const [requestInfo, setRequestInfo, setRequestInfoLocal, requestInfoDate] =
		useRemoteField(`${question_id}.REQUEST`);
	const [response, setResponse, setResponseLocal, responseDate] =
		useRemoteField(`${question_id}.RESPONSE`);
	const [approved, setApproved, , approvedDate] = useRemoteField(
		`${question_id}.APPROVED`,
	);

	return (
		<>
			{locked || approved === "True" ? (
				<>
					<Box>
						<b>Request</b>: {requestInfo}
					</Box>
					<Box>
						<b>Response</b>: {response}
					</Box>
					<Box>
						<b>Approved</b>:{" "}
						{approvedDate && dayjs(approvedDate).format("YYYY-MM-DD")}
					</Box>
				</>
			) : (
				<>
					{/*Additional information required?*/}
					<FormControl>
						<RadioGroup
							row
							value={value}
							onChange={(e) => setValue(e.target.value)}
						>
							<FormControlLabel value="True" control={<Radio />} label="Yes" />
							<FormControlLabel value="False" control={<Radio />} label="No" />
						</RadioGroup>
					</FormControl>

					{value === "True" ? (
						<>
							{/*Text box for additional info prompt*/}
							<TextField
								id={question_id}
								multiline
								rows={5}
								value={requestInfo}
								fullWidth
								onChange={(e) => setRequestInfoLocal(e.target.value)}
								onBlur={(e) => setRequestInfo(e.target.value)}
								label={"Please provide additional details."}
							></TextField>
							<Typography>
								Updated:
								{requestInfoDate && dayjs(requestInfoDate).format("YYYY-MM-DD")}
							</Typography>

							{requestInfo ? (
								<>
									{/*Text box for response to prompt*/}
									<Typography>Response from submitter</Typography>
									<Box>
										<TextField
											id={question_id}
											multiline
											rows={5}
											value={response}
											fullWidth
											onChange={(e) => setResponseLocal(e.target.value)}
											onBlur={(e) => setResponse(e.target.value)}
											label={"Please provide a response."}
										></TextField>
									</Box>
									{/*TODO: Enable file upload in addition to/instead of text field*/}
									<Box>
										<input type="text" id={question_id} />
										<button>Upload File</button>
									</Box>
									<Typography>
										Updated:
										{responseDate && dayjs(responseDate).format("YYYY-MM-DD")}
									</Typography>
								</>
							) : null}

							{response ? (
								<>
									{/*Response approved?*/}
									<Typography>Additional response approved?</Typography>
									<FormControl>
										<RadioGroup
											row
											value={approved}
											onChange={(e) => setApproved(e.target.value)}
										>
											<FormControlLabel
												value="True"
												control={<Radio />}
												label="Yes"
											/>
											<FormControlLabel
												value="False"
												control={<Radio />}
												label="No"
											/>
										</RadioGroup>
									</FormControl>
								</>
							) : null}
						</>
					) : null}
				</>
			)}
		</>
	);
};
